import {Campaign} from '@aboutyou/grpc-clients/tadarida/aysa_api/entities/campaigns/v1/campaign.types';
import {GetDiscountsResponse_Discount} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/campaigns/v1/service.types';

export const isSimpleCampaign = (campaign: Campaign): boolean => {
  switch (campaign.type?.$case) {
    case 'minor':
      return campaign.type.minor.isSimpleBanner;
    case 'reduction':
      return campaign.type.reduction.isSimpleBanner;
    default:
      return false;
  }
};

export const isAppInstallIncentiveCampaign = (campaign: Campaign): boolean => {
  switch (campaign.type?.$case) {
    // Crazy bet / App Flash sale are categorised as `reduction` with `isAppOnlyCampaign`
    case 'reduction':
      return campaign.type.reduction.isAppOnlyCampaign;
    default:
      return false;
  }
};

export const filterSimpleAndAppInstallIncentiveCampaigns = (
  discounts: GetDiscountsResponse_Discount[],
) => {
  return discounts.filter(discount => {
    if (discount.discount?.$case === 'priceReductionCampaign') {
      return (
        !isSimpleCampaign(discount.discount.priceReductionCampaign.campaign) &&
        !isAppInstallIncentiveCampaign(
          discount.discount.priceReductionCampaign.campaign,
        )
      );
    } else {
      return true;
    }
  });
};
